import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { getTicketPaymentFields } from 'components/Filter/TicketFields/getTicketPaymentFields'
import { links } from 'utils/featureToggles'

import Tickets from './Tickets/Tickets'
import { GridColumn, ticketsPaymentsColumn } from './ticketsPaymentsColumn'
import { TicketsViewType } from './TicketsViewType'

const DEFAULT_COLUMN_WIDTH = 150

const normalizeGridColumns = (columns: GridColumn[]): GridColumn[] =>
  columns.map((column) => {
    const isNarrowColumn = column.allowNarrowWidth === true

    const width = isNarrowColumn
      ? column.width
      : Math.max(column.width ?? DEFAULT_COLUMN_WIDTH, DEFAULT_COLUMN_WIDTH)

    return {
      ...column,
      width,
      minResizableWidth: isNarrowColumn
        ? (column.minResizableWidth ?? column.width)
        : DEFAULT_COLUMN_WIDTH,
    }
  })
const TicketsPayments = (): JSX.Element => (
  <React.Fragment>
    <Breadcrumbs crumbs={[{ title: 'Payments Tickets', link: links.ticketsPayments.url }]} />
    <Tickets
      viewType={TicketsViewType.Payments}
      columns={normalizeGridColumns(ticketsPaymentsColumn)}
      filterFields={getTicketPaymentFields}
    />
  </React.Fragment>
)

export default TicketsPayments
